import { Box, Typography } from "@mui/material";
import FilterAltOffOutlinedIcon from "@mui/icons-material/FilterAltOffOutlined";

// Shown when the feed's filters match no products. Mirrors ngwaahia-mobile's
// components/feed/FeedNoResults.js.
const FeedNoResults = () => (
  <Box sx={{ textAlign: "center", py: 4, px: 3 }}>
    <FilterAltOffOutlinedIcon sx={{ fontSize: 48, color: "#046287" }} />
    <Typography
      variant="subtitle1"
      fontWeight={700}
      sx={{ color: "#374151", mt: 1.5, mb: 0.5 }}
    >
      No products match these filters
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Try removing a filter or two to see more.
    </Typography>
  </Box>
);

export default FeedNoResults;
